<div class="spinner-wrapper">
    <mat-spinner [diameter]="diameter"></mat-spinner>
    <span *ngIf="showText" t7e="loading">Loading...</span>
</div>
